import { Provider } from '@angular/core';

import { ReportsDataHttpService } from './abstract';
import { ReportsDataHttpServiceImpl } from './reports-data-http.service';

export const ReportsDataHttpProvider: Provider = {
	provide: ReportsDataHttpService,
	useClass: ReportsDataHttpServiceImpl,
};
